export default "__VITE_ASSET__60d5853e__"